import {Component, OnInit} from '@angular/core';
import {EventDto, EventService} from '../../services/event.service';
import {ActivatedRoute, Router} from '@angular/router';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-event-detail',
  templateUrl: './event-detail.component.html',
  styleUrls: ['./event-detail.component.css']
})
export class EventDetailComponent implements OnInit {

  constructor(public eventService: EventService,
              private route: ActivatedRoute,
              private router: Router,
              private _matSnackBar : MatSnackBar,
              private _shoppingCartService :ShoppingCartService) {
  }

  event: EventDto;
  showYoutube = false;
  showImage = false;
  showPlaceHolder = false;

  ngOnInit() {
    this.event = this.eventService.selectedEvent;
    // console.log(this.event.media);
    // console.log(this.event.media.image);
    // console.log(this.event.media.youtube);
    if (this.event.media && this.event.media.youtube) {
      this.showYoutube = true;
    } else if (this.event.media && this.event.media.image) {
      this.showImage = true;
    } else {
      this.showPlaceHolder = true;
    }
  }
  addToCart(){
    this._shoppingCartService.addTicket(this.event);
    this._matSnackBar.open(
      `${this.event.eventName} added to your shopping cart.`, '',
      {
        duration: 1000,
      }
      );
  }
  gotToEventList() {
    this.router.navigate([
      this.route.snapshot.params['username'], 'event-list'
    ]);
  }

}
